import antdData from 'antd/lib/locale-provider/ru_RU'
import localeData from 'react-intl/locale-data/ru'

const messages = {
  'topBar.issuesHistory': 'История заданий',
  'topBar.projectManagement': 'Управление проектом',
  'topBar.typeToSearch': 'Поиск...',
  'topBar.buyNow': 'Купить $26',
  'topBar.bitcoin': 'Биткоин',
  'topBar.profileMenu.hello': 'Привет',
  'topBar.profileMenu.billingPlan': 'Тарифный план',
  'topBar.profileMenu.role': 'Роль',
  'topBar.profileMenu.email': 'Емайл',
  'topBar.profileMenu.phone': 'Телефон',
  'topBar.profileMenu.editProfile': 'Редактировать профиль',
  'topBar.profileMenu.logout': 'Выйти',
  'topBar.profileMenu.Tous': 'Выйти',

  'sec1.header1' : 'ОТСЛЕДИТЕ ИСТОРИЮ ПРОИЗВОДСТВА',
  'sec1.header2' : 'ВАШИХ ЮВЕЛИРНЫХ УКРАШЕНИЙ',
  'sec1.text' : 'Говорить об экологической ответственности – значит говорить о прослеживаемости. TOUS – одна из первых компаний, которые стали раскрывать подробную информацию о продукции: начиная с добычи сырья и до момента доставки украшений вам. Наличие знака «Tracemark» говорит о том, что изделие состоит из материалов, добытых и обработанных с соблюдением принципов социальной и экологической ответственности на 100%.',

  'sec2.description' : 'Описание:',
  'sec2.button' : 'ID DIGITAL',

  'rawMaterials.header' : 'Сырье',
  'rawMaterials.header.text' : 'золото и бриллианты, добытые в соответствии с международными стандартами',

  'rawMaterials.sec1.header1' : 'ЗОЛОТО, ДОБЫТОЕ В СООТВЕТСТВИИ ',
  'rawMaterials.sec1.header2' : 'СО СТАНДАРТАМИ СОВЕТА ПО ОТВЕТСТВЕННОЙ ЮВЕЛИРНОЙ ПРАКТИКЕ',
  'rawMaterials.sec1.text1.1' : 'Это изделие произведено из золота, приобретаемого только у аффинажных заводов, работающих с соблюдением принципов ответственности на всех этапах цепочки поставок, и со строгим контролем за обеспечением сохранности золота. Стандарты ',
  'rawMaterials.sec1.text1.2' : 'Совета по ответственной ювелирной практике ', 
  'rawMaterials.sec1.text1.3' : '(RJC – Responsible Jewellery Council) гарантируют, что золото было добыто в соответствии с Кодексом практик RJC при соблюдении принципов социальной и экологической ответственности.',
  'rawMaterials.sec1.text2' : 'Золото, используемое для создания этого ювелирного изделия, поступает из источников, которые были проверены и соответствуют лучшим международным экологическим практикам и социальным стандартам, признанным во всем мире.',
  'rawMaterials.sec1.notTraceableMaterial' : 'Материал без Tracemark: ',

  'rawMaterials.sec2.header1' : 'БРИЛЛИАНТЫ С ОТКРЫТОЙ',
  'rawMaterials.sec2.header2' : 'ЦЕПОЧКОЙ ПРОИЗВОДСТВА, ',
  'rawMaterials.sec2.header3' : 'ДОБЫТЫЕ С ДОЛЖНОЙ ОТВЕТСТВЕННОСТЬЮ',
  'rawMaterials.sec2.text1.1' : 'Бриллианты, использованные для создания этого ювелирного изделия, приобретены у горнодобывающей компании ',
  'rawMaterials.sec2.text1.2' : ', сертифицированного члена RJC, или DeBeersSightholder, что гарантирует их добычу с соблюдением принципов ответственности и соответствие практикам социально-экологической ответственности на всех этапах цепочки поставок.',
  'rawMaterials.sec2.text2' : 'Страна происхождения бриллиантов: ',
  'rawMaterials.sec2.text3' : 'Каждый бриллиант имеет индивидуальный сертификат в соответствии со схемой сертификации процесса Кимберли. Данный сертификат подтверждает подлинность бриллианта, его происхождение и добычу с соблюдением норм этики.',
  'rawMaterials.sec2.text4.1' : 'Предназначенная для предотвращения поступления на рынок алмазов из зон конфликтов, ',
  'rawMaterials.sec2.text4.2' : 'схема сертификации процесса Кимберли',
  'rawMaterials.sec2.text4.3' : 'накладывает существенные обязательства на всех участников, чтобы их поставки необработанных алмазов можно было сертифицировать как «свободные от конфликтов».',   

  'fabricationProcess.header1' : 'ПРОЦЕСС ПРОИЗВОДСТВА: ',
  'fabricationProcess.header2' : 'ИСКУССТВО МАСТЕРОВ',

  'fabricationProcess.text1' : 'Создание ювелирного изделия начинается с вдохновения – эмоции или идеи, которая затем преобразуется в дизайн. В процессе производства, совмещающего традиции ювелирного ремесла и инновационные техники, опытные ювелиры превращают разработанный дизайн в уникальные украшения. Это изделие создано на юге Испании, в Кордове. От моделирования и литья, до отделки, закрепки и полировки – наши мастера из Кордовы дарят форму ювелирным изделиям со страстью и высочайшим профессионализмом.',
  'fabricationProcess.text2' : 'Вся документация и информация о происхождении этого украшения была проверена внешним аудитором, аккредитованным RJC.',

  'certificates' : 'СЕРТИФИКАТЫ',
  'download' : 'Скачать',


  'digitalPass.header' : 'Get your Tracemark ID',
   'digitalPass.step1' : 'Authenticate your piece',
   'digitalPass.step2' : 'Generate Tracemark ID',

   'digitalPass.uniqueCode' : 'Unique alphanumeric code as appears on your piece of jewelry and tag',
   'digitalPass.Authenticate' : 'Authenticate',

   'digitalPass.personalDetails' : 'Personal Details',
   'digitalPass.email' : 'Email',
   'digitalPass.firstName' : 'First Name',
   'digitalPass.lastName' : 'Last Name',
   'digitalPass.password.text1' : 'Set a password',
   'digitalPass.password.text2' : 'Please set a password to register your ownership of this piece of jewelry and secure your Tracemark ID:',
   'digitalPass.password' : 'Password',
   'digitalPass.confirmPassword' : 'Confirm Password',
   'digitalPass.generateTracemarkIDButton' : 'Generate Tracemark ID',

   'digitalPass.notificationHeader' : 'Your Tracemark ID is downloading',
   'digitalPass.notificationText' : 'We have also sent it to you using the email address provided. Open the attached Tracemark ID on your smartphone to save it to your digital wallet.',

   'digitalPass.termsAndCondition1' : 'I have read and expressly accept the',
   'digitalPass.termsAndCondition2' : 'of "TRACEABLE LUXURY SERVICES, S.L." and the conditions for the processing of my personal data.',

   /* ----------- Start Delete TracemarkID Popup ------------- */

   'deleteTracemarkID.link' : 'Reset ownership to delete my Tracemark ID',
   'deleteTracemarkID.modal.header' : 'Reset Tracemark ID',
   
   'deleteTracemarkID.step1.password' : 'Insert your password',
   'deleteTracemarkID.step1.button' : 'Validate',
   'deleteTracemarkID.step1.forgotPasswordLink' : 'I forgot my password',

   'deleteTracemarkID.step2.resetText' : 'Please type the word RESET to confirm resetting your Tracemark ID and to allow for the ownership of this piece to be changed or for the piece to be returned.',
   
   'deleteTracemarkID.step3.success' : 'Thank you. The ownership and Tracemark ID for this piece have been reset.',

   /* ----------- End Delete TracemarkID Popup ------------- */

   'downloadCertificate.text1' : 'To download the Tracemark certificate for this piece, please provide the password used to register its ownership. This is the same password used to download your Tracemark ID.',
   'downloadCertificate.text2' : 'If you have not registered this piece’s ownership, please do so above before downloading this piece’s Tracemark certificate.',

   'downloadCertificate.success' : 'You will shortly receive an email with the Tracemark certificate for this piece attached, delivered to the address used to register its ownership.',

   'downloadCertificate.title' : "Download Certificate",
   'Consumer.download' : 'Download',

   /* ----------- Start Tous version 2(v2) changes ------------- */ 
   'rawMaterials.sec2.v2.text1':'Бриллианты в этом украшении получены от огранщика, который является членом De Beers Sightholders, что обеспечивает ответственный подход к выбору поставщиков и соблюдение устойчивой практики на протяжении всей цепочки поставок.',
   'rawMaterials.sec2.v2.text2':'Каждый бриллиант подтверждается собственным сертификатом Кимберлийского процесса, который удостоверяет его подлинность, происхождение и этичность добычи.',
   'rawMaterials.sec2.v2.text3':'Сертификация в рамках Кимберлийского процесса предъявляет к его участникам обширные требования, позволяющие им сертифицировать партии алмазного сырья как "свободные от конфликтов" и предотвращать попадание конфликтных алмазов в законную торговлю.'
   /* ----------- End Tous version 2(v2) changes ------------- */
}

export default {
  locale: 'ru-RU',
  antdData,
  localeData,
  messages,
}
